module.exports = __webpack_public_path__ + "media/images/p8-ee63ed650102049d886973a8f95491b0.jpg";